// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-us{
  position: relative;
}

.contact-us .form-group {
  margin-bottom: 20px;
}

.contact-us form label {
  color: #818181;
  position: absolute;
  padding: 10px;
  font-size: 12px;
  z-index: 1;
}

.contact-us form input {
  padding-top: 1.825rem;
  padding-bottom: 0.625rem;
}

.contact-us form select {
  padding-top: 1.825rem;
  padding-bottom: 0.625rem;
  position: relative;
  appearance: auto;
  color: #818181;
  padding-left: 7px;
}

.contact-us form textarea {
  padding-top: 1.825rem;
}

.create-case{
  position: absolute;
  right: 15px;
  top: 30px;
}

.contactus-form.hide{
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ContactUs.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAElB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;AACf","sourcesContent":[".contact-us{\r\n  position: relative;\r\n}\r\n\r\n.contact-us .form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.contact-us form label {\r\n  color: #818181;\r\n  position: absolute;\r\n  padding: 10px;\r\n  font-size: 12px;\r\n  z-index: 1;\r\n}\r\n\r\n.contact-us form input {\r\n  padding-top: 1.825rem;\r\n  padding-bottom: 0.625rem;\r\n}\r\n\r\n.contact-us form select {\r\n  padding-top: 1.825rem;\r\n  padding-bottom: 0.625rem;\r\n  position: relative;\r\n  -webkit-appearance: auto;\r\n  appearance: auto;\r\n  color: #818181;\r\n  padding-left: 7px;\r\n}\r\n\r\n.contact-us form textarea {\r\n  padding-top: 1.825rem;\r\n}\r\n\r\n.create-case{\r\n  position: absolute;\r\n  right: 15px;\r\n  top: 30px;\r\n}\r\n\r\n.contactus-form.hide{\r\n  display: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
